import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Table, Form } from 'react-bootstrap';
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import '../../assets/css/brandbook.css';
import { Sidebar } from 'primereact/sidebar';
import { Calendar } from 'primereact/calendar';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import CustomToast from '../../components/CustomToast';

import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from 'primereact/fileupload';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { AutoComplete } from "primereact/autocomplete";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Badge } from 'primereact/badge';


const Post_upload = () => {
    const { accessToken } = useAuth();
    const toastRef = useRef(null); // Reference for the CustomToast component
    // State for dialog and form
    const [showUploadDialog, setShowUploadDialog] = useState(false);
    const [showPreviewDialog, setShowPreviewDialog] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [selectedqueryBrand, setSelectedqueryBrand] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [csvData, setCsvData] = useState([]);
    const [fileName, setFileName] = useState("");
    const [isCsvLoaded, setIsCsvLoaded] = useState(false);


    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState([]);

    // Show toast message function
    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    const [date, setDate] = useState(null);


    // Fetch brands from the API
    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetchallbrands`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setBrands(response.data || []);
        } catch (error) {
            console.error("Error fetching brands:", error);
        }
    };
    useEffect(() => {
        fetchBrands();
    }, [accessToken]);

    // Filter brands for autocomplete
    const searchBrands = (event) => {
        const query = event.query.toLowerCase();
        setFilteredBrands(
            brands.filter((brand) =>
                brand.brand_name.toLowerCase().includes(query)
            )
        );
    };

    // Month options
    const monthOptions = [
        { label: "January", value: 1 },
        { label: "February", value: 2 },
        { label: "March", value: 3 },
        { label: "April", value: 4 },
        { label: "May", value: 5 },
        { label: "June", value: 6 },
        { label: "July", value: 7 },
        { label: "August", value: 8 },
        { label: "September", value: 9 },
        { label: "October", value: 10 },
        { label: "November", value: 11 },
        { label: "December", value: 12 },
    ];

    // Year options (Generate dynamically)
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 5 }, (_, i) => ({
        label: currentYear - i,
        value: currentYear - i,
    }));

    const handleCloseUploadDialog = () => {
        setShowUploadDialog(false);
        setSelectedBrand(null);
        setSelectedMonth(null);
        setSelectedYear(null);
        setFileName(null);
        setCsvData([]);
        setIsCsvLoaded(false);
    };



    const handleFileUpload = (event) => {
        const file = event.files[0]; // PrimeReact FileUpload uses event.files array
        if (!file) return;

        setFileName(file.name);
        setIsCsvLoaded(false); // Reset state before processing

        const reader = new FileReader();

        // Process CSV file
        if (file.name.endsWith('.csv')) {
            reader.onload = ({ target }) => {
                Papa.parse(target.result, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (result) => {
                        setCsvData(result.data);
                        setIsCsvLoaded(true);
                    }
                });
            };
            reader.readAsText(file);
        }
        // Process Excel file (XLSX, XLS)
        else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
            reader.onload = ({ target }) => {
                const workbook = XLSX.read(target.result, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);

                setCsvData(jsonData);
                setIsCsvLoaded(true);
            };
            reader.readAsBinaryString(file);
        }
        // Unsupported file type
        else {
            showMessage("error", "Unsupported file format. Please upload CSV or Excel files.");
        }
    };

    const handleClear = () => {
        setFileName('');
        setCsvData([]);
        setIsCsvLoaded(false);
    };


    // Placeholder function for saving data
    const handleSave = () => {
        console.log("Save function will be implemented here.");
    };

    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col lg={12} className="mb-4 d-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Upload Data Sheet</Breadcrumb.Item>
                        </Breadcrumb>
                        <Button
                            severity="warning"
                            label="Upload Excel"
                            icon="pi pi-upload"
                            className="py-2 border-0"
                            onClick={() => setShowUploadDialog(true)}
                        />
                    </Col>
                    <Col lg={12} className="p-0">
                        <Row className="mx-0">
                            <Col lg={3} className="">
                                <ul className="BrandEX sticky-top">
                                    <li className="active">
                                        <div className="blogo">A</div>
                                        <h6>ATS</h6>
                                    </li>
                                    <li>
                                        <div className="blogo">F</div>
                                        <h6>FOY</h6>
                                    </li>
                                </ul>
                            </Col>
                            <Col lg={9} className="multipleAccordian">
                                <Accordion activeIndex={0}>
                                    <AccordionTab 
                                        className="accordion_one"
                                        header={
                                            <span className="d-flex align-items-center gap-2 justify-content-between w-full">
                                                <span className="font-bold white-space-nowrap">March 2025 </span>
                                                <Badge 
                                                    value="50" 
                                                    severity='danger'
                                                    className="accor_badge"
                                                />
                                            </span>
                                        }
                                    >
                                        <Accordion className="childaccordian" activeIndex={0}>
                                            <AccordionTab
                                                header={
                                                    <span className="d-flex align-items-center gap-2 justify-content-between w-full">
                                                        <span className="font-bold white-space-nowrap">Post Type : Carousel</span>
                                                        <Link to="/Graphe/dashboard/addbook">
                                                            <Button
                                                            icon="pi pi-pencil"
                                                            className="p-0 border-0 position-relative"
                                                            text
                                                            severity="secondary"
                                                            zindex="1"
                                                        />
                                                        </Link>
                                                    </span>
                                                }
                                            >
                                              <div className="accord_table meet_notul">
                                                <Table size="sm" >
                                                    <tbody>
                                                        <tr>
                                                            <td>Topic</td>
                                                            <td>Occasional - Valentine's Day</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Visual Idea + Reference</td>
                                                            <td>Paddle reflection as a heart</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Copy</td>
                                                            <td>Match Made in Heaven. #ValentinesDay</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Caption</td>
                                                            <td>
                                                                Split image with two sides: On the left: A playful, lighthearted Bumble profile with hearts. On the right: A powerful image of someone smashing a pickleball with a Grytskill paddle
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Keywords + Hashtags</td>
                                                            <td>Matching for Others vs. Matching for Picklers #ValentinesDay</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                              </div>
                                            </AccordionTab>
                                            <AccordionTab
                                                header={
                                                    <span className="flex align-items-center gap-2 w-full">
                                                        <span className="font-bold white-space-nowrap">Sub Item 2</span>
                                                    </span>
                                                }
                                            >
                                                Content for Sub Item 2
                                            </AccordionTab>
                                        </Accordion>
                                        
                                    </AccordionTab>
                                </Accordion>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <CustomToast ref={toastRef} />
            </Row>

            {/* Upload Dialog */}
            <Dialog
                visible={showUploadDialog}
                onHide={handleCloseUploadDialog} // Call function to reset data
                header="Upload Data Sheet"
                style={{ width: "500px" }}
            >
                {/* Prevent form submission */}
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="mb-3">
                        <label>Brand</label>
                        <AutoComplete
                            value={selectedBrand}
                            suggestions={filteredBrands}
                            completeMethod={searchBrands}
                            field="brand_name"
                            onChange={(e) => setSelectedBrand(e.value)}
                            placeholder="Select Brand"
                            className="mx-1 mx-lg-2 w-100"

                        />
                    </div>

                    <div className="mb-3">
                        <label>Month</label>
                        <Dropdown
                            value={selectedMonth}
                            options={monthOptions}
                            onChange={(e) => setSelectedMonth(e.value)}
                            placeholder="Select Month"
                            className="w-100"
                        />
                    </div>

                    <div className="mb-3">
                        <label>Year</label>
                        <Dropdown
                            value={selectedYear}
                            options={yearOptions}
                            onChange={(e) => setSelectedYear(e.value)}
                            placeholder="Select Year"
                            className="w-100"
                        />
                    </div>

                    {/* Show file upload only after selecting required fields */}
                    {selectedBrand && selectedMonth && selectedYear && (
                        <>
                            <div className="d-flex  card">
                                <div className=" mb-3">

                                    <FileUpload
                                        name="file"
                                        accept=".csv, .xlsx, .xls"
                                        maxFileSize={1000000}
                                        mode="basic"
                                        chooseLabel="Choose File"
                                        customUpload
                                        uploadHandler={handleFileUpload}
                                        multiple={false} // Ensures only one file is uploaded
                                    />
                                    {fileName && <p>Uploaded File: {fileName}</p>}
                                </div>
                                <div>
                                    {fileName && (
                                        <Button
                                            title="Remove File"
                                            icon="pi pi-trash"
                                            className="p-button-danger mt-2"
                                            onClick={handleClear}
                                        />
                                    )}
                                </div>

                            </div>



                            {/* Ensure CSV is fully loaded before showing Preview button */}
                            {csvData.length > 0 && isCsvLoaded && (
                                <Button
                                    severity="info"
                                    label="Preview Data"
                                    icon="pi pi-eye"
                                    className="mt-3"
                                    type="button" // Ensure it's NOT a submit button
                                    onClick={() => setShowPreviewDialog(true)}
                                />
                            )}
                        </>
                    )}
                </form>
            </Dialog>


            {/* Preview Dialog */}
            <Dialog
                visible={showPreviewDialog}
                onHide={() => setShowPreviewDialog(false)}
                header="CSV Data Preview"
                maximizable
                style={{ width: '50vw' }}
                footer={ // Footer Content
                    <Button
                        severity="success"
                        label="Save Data"
                        onClick={handleSave}
                        disabled={csvData.length === 0}
                    />
                }
            >
                {csvData.length > 0 ? (
                    <div >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    {Object.keys(csvData[0]).map((key, index) => (
                                        <th key={index}>{key}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {csvData.map((row, index) => (
                                    <tr key={index}>
                                        {Object.values(row).map((value, i) => (
                                            <td key={i}>{value}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p>No data to preview.</p>
                )}
            </Dialog>

        </>
    );
};

export default Post_upload;